import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { FieldReviewDetailsRow } from "../fieldReviewDetailsViewConfig";

export const FieldReviewBankDescriptionCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, FieldReviewDetailsRow, string>) => {
        const { bankDescription } = row.original;
        return (
            <ViewTableCell>
                <BreakableText text={bankDescription} showTooltip />
            </ViewTableCell>
        );
    },
);

FieldReviewBankDescriptionCell.displayName = "FieldReviewBankDescriptionCell";
